const MarqueeStrip = () => {
  const text = "DIVINE FLOW \u2014 SOMATIC MOVEMENT \u2014 SOUND HEALING \u2014 AFRO-CUBAN DANCE \u2014 ";
  
  return (
    <div
      data-testid="marquee-strip"
      className="py-5 bg-[#EBE6DF] border-y border-[#DCD6CC] overflow-hidden"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {[...Array(4)].map((_, i) => (
          <span
            key={i}
            className="font-['Cormorant_Garamond'] text-lg md:text-xl text-[#596B5B] tracking-wider px-2"
          >
            {text}
          </span>
        ))}
      </div>
    </div>
  );
};

export default MarqueeStrip;
